<template>
  <div class="domaine-container">

    <div class="header-container">
      <div class="header">
        <div class="navbar">
          <app-accueil-navbar @toggleMenu="toggleMenuTwo" :open="menuShowed"></app-accueil-navbar>
        </div>

        <div class="image-header">
          <div class="header-content">
            <div class="space"></div>
            <h1>Ce serait un plaisir<br>de <span>vous rencontrer</span></h1>
            <div class="texte">
              <div class="background-blue"></div>
              <p>
                CYBERDINE CONSEIL est en permanence à la recherche de nouveaux talents,<br>
                et de nouvelles perspectives d’activités.
              </p>
              <img src="../../img/contact-component/petit_bidul_barre_transparente.svg" alt="">
            </div>
          </div>
        </div>

        <transition name="size-menu">
          <app-accueil-hamburger v-if="this.menuShowed"></app-accueil-hamburger>
        </transition>

        <transition name="opacity">
          <div class="shadow" v-if="this.menuShowed" @click="toggleMenuTwo"></div>
        </transition>
      </div>

    </div>

    <div class="content flex-column">

      <div class="contact-container flex-row-space-evenly">
        <div class="section">
          <h2>On fait connaissance ?</h2>
          <p>
            Vous voulez en savoir plus, obtenir des informations sur nos offres
            ou le détail précis de nos activités, n’hésitez pas, écrivez-nous !
          </p>
          <button @click="changeTo('societe')">En savoir plus</button>
          <h3>CYBERDINE CONSEIL</h3>
          <div class="flex-row infos">
            <img src="../../img/contact-component/adresse_contact.svg" alt="">
            <span>Rue de l'Indre - Quartier EURONANTES - 44000 NANTES</span>
          </div>
          <div class="flex-row infos">
            <a href="mailto:contact@cyberdineconseil.fr"><img src="../../img/contact-component/enveloppe_contact.svg" alt=""></a>
            <span>contact@cyberdineconseil.fr</span>
          </div>
        </div>

        <div class="section form-contact">
          <h2>Nous contacter</h2>
          <input type="text" class="length-1 nom" placeholder="Nom" v-model="nom">
          <input type="text" class="length-1 prenom" placeholder="Prénom" v-model="prenom">
          <!--<input type="email" class="length-2" placeholder="Adresse email">-->
          <textarea placeholder="Infos..." id="" cols="30" rows="10" class="length-2" v-model="body"></textarea>
          <a :href="'mailto:contact@cyberdineconseil.fr?subject=Ciberdine contact&body='+this.bodyWithReturn+'%0D%0A-%0D%0A'+this.nom+' '+this.prenom"><button>Envoyer</button></a>
        </div>
      </div>

    </div>

    <app-contact></app-contact>

    <app-footer></app-footer>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    import Navbar from "./Navbar";
    import Footer from "../Footer";
    import HamburgerMenu from "../accueil/HamburgerMenu";
    import Contact from "../accueil/Contact";

  export default {
      data() {
          return {
              menuShowed: false,
              nom: "",
              prenom: "",
              email: "",
              body: "",
          }
      },
      computed: {
          bodyWithReturn() {
              return this.body.replaceAll('\n', '%0D%0A');
          }
      },
      methods: {
          toggleMenuTwo() {
              this.menuShowed = !this.menuShowed;
              if (this.menuShowed) {
                  document.getElementsByTagName('body')[0].classList.add('blocked');
              }
              else {
                  document.getElementsByTagName('body')[0].classList.remove('blocked');
              }
          },
          changeTo(pageName) {
              menuBus.$emit('changePage', pageName);
          }
      },
      mounted() {
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      },
    components: {
        'app-accueil-navbar': Navbar,
        'app-footer': Footer,
        'app-contact': Contact,
        'app-accueil-hamburger': HamburgerMenu,
    }
  }
</script>

<style scoped>
  .header-container {
    z-index: 100;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .header {
    position: relative;
    height: 100vh;
    min-height: 600px;
  }
  .navbar {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 100;
  }

  .image-header {
    position: absolute;
    height: 100vh;
    min-height: 650px;
    width: 100%;

    background: url("../../img/contact-component/En_tete_contact.jpg") no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .image-header .space {
    height: 200px;
  }
  .image-header .header-content {
    position: absolute;
    left: 150px;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100% - 150px);
    text-align: left;
  }
  .image-header h1 {
    z-index: 10;

    font-size: 100px;
    color: white;
    font-weight: 900;
    line-height: 0.9;
  }
  .image-header h1 span {
    color: #b7e17e;
  }
  .image-header .texte {
    width: fit-content;
    margin: 0;
    font-size: 30px;
    padding: 20px;
    position: relative;
  }
  .image-header .texte .background-blue {
    background-color: rgba(22, 33, 57, 0.6);
    height: 100%;
    width: 95%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .image-header .texte img {
    height: 152%;
    width: calc(5% + 50px);
    position: absolute;
    bottom: 0;
    left: 95%;
    z-index: -1;
  }
  .image-header p {
    width: fit-content;
    margin: 0;
    color: white;
    font-weight: 300;
    font-size: 30px;
  }

  .space {
    height: 0px!important;
  }

  .content {
    position: relative;
    overflow-y: hidden;
  }
  .content * {
    z-index: 10;
  }

  .contact-container {
    width: 100%;
    align-items: flex-start;
    margin-bottom: 50px;
  }

  .section {
    width: calc(50% - 100px);
    text-align: left;
  }
  .section h2 {
    color: #162139;
    font-size: 60px;
    font-weight: 900;
    width: 100%;
  }
  .section p {
    color: #9fa8bd;
    font-size: 20px;
    font-weight: 300;
    max-width: 480px;
  }
  .section button {
    font-size: 20px;
    text-transform: uppercase;
    background-color: #b7e17e;
    padding: 20px;
    color: white;
    border: 2px solid rgba(183, 225, 126, 0);
    cursor: pointer;
    margin-top: 20px;
    margin-bottom: 50px;
    transition: all 0.2s;
  }
  .section button:hover {
    border: 2px solid #b7e17e;
    color: #b7e17e;
    background: none;
  }
  .section h3 {
    color: #162139;
    font-size: 30px;
    font-weight: 900;
  }
  .section .infos {
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 20px;
  }
  .section .infos img {
    height: 50px;
    margin-right: 40px;
  }
  .section .infos span {
    font-size: 20px;
    overflow-wrap: anywhere;
  }

  .form-contact {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .section input, .section textarea {
    background-color: #f1f2f6;
    border: none;
    margin-bottom: 20px;
    padding: 0 20px;
    font-size: 20px;
  }
  .section textarea {
    padding-top: 20px;
    resize: vertical;
  }
  .section input {
    height: 80px;
  }
  .section .nom {
    margin-right: 20px;
  }
  .section .length-1 {
    width: calc(50% - 50px);
  }
  .section .length-2 {
    width: 100%;
  }

  /* Tablet */
  @media (max-width: 1300px) {
    .image-header h1 {
      font-size: 60px;
    }
    .header-content {
      left: 70px!important;
    }
  }
  @media (max-width: 1000px) {
    .contact-container {
      flex-direction: column;
      margin-left: 100px;
      width: calc(100% - 100px);
    }
    .contact-container .section {
      width: calc(100% - 100px);
    }
    .section input {

    }
  }

  /* Mobile */
  @media (max-width: 800px) {
    .image-header h1 {
      font-size: 35px;
    }
    .image-header p {
      font-size: 15px;
    }
    .header-content {
      left: 50px!important;
    }
    .space {
      height: 100px!important;
    }
  }
  @media (max-width: 650px) {
    .contact-container {
      margin-left: 0;
      width: 80%;
    }
    .length-1 {
      width: 100% !important;
    }
    .nom {
      margin-right: 0!important;
    }
    .content h2 {
      font-size: 40px;
    }
    .content h3 {
      font-size: 20px;
    }
    .contact-container .section {
      width: 100%;
    }
  }
  @media (max-width: 600px) {

  }
  @media (max-width: 550px) {

  }
  @media (max-width: 500px) {

  }

  .size-menu-enter-active,
  .size-menu-leave-active {
    transition: all 0.5s;
    max-height: 500px!important;
  }
  .size-menu-enter,
  .size-menu-leave-to
  {
    opacity: 0;
    max-height: 0px!important;
  }

  .shadow {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 60;
    position: fixed;
  }

  .opacity-enter-active,
  .opacity-leave-active {
    transition: all 0.5s;
  }
  .opacity-enter,
  .opacity-leave-to
  {
    opacity: 0;
  }

  @media (min-width: 1100px) {
    .shadow {
      display: none!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue